import { render, staticRenderFns } from "./PropertyInfo.vue?vue&type=template&id=4728e9ea&scoped=true"
import script from "./PropertyInfo.vue?vue&type=script&lang=js"
export * from "./PropertyInfo.vue?vue&type=script&lang=js"
import style0 from "./PropertyInfo.vue?vue&type=style&index=0&id=4728e9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4728e9ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VFlex,VLayout,VList,VListItemContent})
